// submitProfileInfo.js
'use strict';
import 'isomorphic-fetch';
import { v4 as uuidv4 } from 'uuid';

import getMeData from '../selector/getMeData.js';
import getOperationData from '../selector/getOperationData.js';
import removeModals from '../action/removeModals.js';
import patchMeData from '../action/patchMeData.js';
import addAsset from '../action/addAsset.js';
import addUploadJob from '../action/addUploadJob.js';
import { Purpose as AssetPurpose } from '../resource/assetConstants.js';
import { Entry as UploadEntry } from '../resource/uploadConstants.js';
import { ProfileField } from '../resource/profileConstants.js';

import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

const filedPurposeMap = {
  [ProfileField.BACKGROUND]: AssetPurpose.ME_BACKGROUND,
  [ProfileField.PICTURE]: AssetPurpose.ME_PICTURE,
};

const fields = [
  ProfileField.BIOGRAPHY,
  ProfileField.BACKGROUND,
  ProfileField.PICTURE,
];

/**
 * Submit profile biography
 * @kind action
 * @return {Promise} Action promise.
 */

const submitProfileInfo = () => async (dispatch, getState) => {
  const token = getMeData(getState(), 'token');
  if (!token) {
    return { type: '' };
  }
  const currentState = getState();
  const changedKeys = fields.filter(key =>
    getOperationData(currentState, ['myProfileInfoDraft'], `${key}:isChanged`)
  );
  const getIsFileKey = key => {
    const data = getOperationData(currentState, ['myProfileInfoDraft'], key);
    return data instanceof File;
  };
  const fileKeys = changedKeys.filter(getIsFileKey);
  // the keys that value is not a file instance
  const otherKeys = changedKeys.filter(key => !getIsFileKey(key));
  if (fileKeys.length > 0) {
    const uploadJobId = uuidv4();
    const assetIds = await Promise.all(
      fileKeys.map(async key => {
        const purpose = filedPurposeMap[key];
        const file = getOperationData(
          currentState,
          ['myProfileInfoDraft'],
          key
        );
        const assetId = uuidv4();
        dispatch(
          addAsset({
            assetId,
            uploadJobId,
            purpose,
            file,
          })
        );
        return assetId;
      })
    );
    dispatch(
      addUploadJob({
        uploadJobId,
        type: UploadEntry.ME,
        assetIds,
      })
    );
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['myProfileInfoDraft'],
        data: {
          uploadJobId,
        },
      },
    });
  }
  if (otherKeys.length > 0) {
    dispatch(
      patchMeData({
        data: {
          [ProfileField.BIOGRAPHY]: getOperationData(
            currentState,
            ['myProfileInfoDraft'],
            ProfileField.BIOGRAPHY
          ),
        },
      })
    );
  }
  dispatch(
    removeModals({
      ids: ['ProfileInfoEditor'],
      transitionStatus: 'closing',
    })
  );
};

export default submitProfileInfo;
